<!--
  preserveAspectRatio of xMidYMid meet as the center of the viewport is the circle's
  center. The center of the circle will remain at the center of the md-progress-spinner
  element containing the SVG.
-->
<svg viewBox="0 0 100 100" preserveAspectRatio="xMidYMid meet">
  <path></path>
</svg>


// WEBPACK FOOTER //
// ./node_modules/ng-mdb-pro/pro/progressbars/progress-spinner-module/progress-spinner.component.html